import React from 'react';
import {PAGINATION} from "../../common/constant";
import {lastSelectedMonth, nextSelectedMonth} from "./filters";

const fields = {
    category: true,
    date: true,
    members: true,
    description: true,
    expanse: true,
    amount: true,
    createdBy: true,
    updatedBy: true,
};

const initialState = {
    loading: false,
    addTrip: {flag: false, data: {}},
    addReimbursement: {flag: false, data: {}, tripDetails: '', view: false},
    fields: fields,
    reimbursementListFilter: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        startDate: lastSelectedMonth(1),
        endDate: nextSelectedMonth(1),
        createdAtStartDate: '',
        createdAtEndDate: '',
    },
    withoutReimbursementListFilter: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        // year: new Date().getFullYear(),
        // month: new Date().getMonth() + 1,
        startDate: lastSelectedMonth(1),
        endDate: nextSelectedMonth(1),
        createdAtStartDate: '',
        createdAtEndDate: '',
    },
    reimbursementDetailsFilter: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        startDate: lastSelectedMonth(1),
        endDate: nextSelectedMonth(1),
        createdAtStartDate: '',
        createdAtEndDate: '',
    },
    withoutReimbursementDetailsFilter: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
    },
};


export default function (state = initialState, action) {
    switch (action.type) {
        case 'SET_LOADING': {
            return {...state, loading: action.payload};
        }
        case 'SET_ADD_TRIP_MODAL': {
            return {...state, addTrip: {...state.addTrip, ...action.payload}};
        }
        case 'SET_ADD_REIMBURSEMENT_MODAL': {
            return {...state, addReimbursement: {...state.addReimbursement, ...action.payload}};
        }
        case 'SET_REIMBURSEMENT_LIST_FILTER': {
            return {...state, reimbursementListFilter: {...state.reimbursementListFilter, ...action.payload}};
        }
        case 'SET_WITHOUT_REIMBURSEMENT_LIST_FILTER': {
            return {...state, withoutReimbursementListFilter: {...state.withoutReimbursementListFilter, ...action.payload}};
        }
        case 'SET_REIMBURSEMENT_DETAILS_FILTER': {
            return {...state, reimbursementDetailsFilter: {...state.reimbursementDetailsFilter, ...action.payload}};
        }
        case 'SET_WITHOUT_REIMBURSEMENT_DETAILS_FILTER': {
            return {...state, withoutReimbursementDetailsFilter: {...state.withoutReimbursementDetailsFilter, ...action.payload}};
        }
        case 'SET_REIMBURSEMENT_REQUEST_FIELDS': {
            return {...state, fields: {...state.fields, ...action.payload}};
        }
        default: {
            return state;
        }
    }
}
